import React from "react";
import Data from "../../assets/data/data";

const Service = () => {
  return (
    <div className="py-14 px-5 sm:px-14 md:px-16 lg:px-20">
      <div className="font-bold text-center font-fairDisplay text-2xl lg:text-4xl text-white relative">
        Our Services
        <div className="after:absolute after:content-['........'] after:bottom-[-26px] after:right-[22%] md:after:right-[40%] lg:after:right-[40%] after:tracking-[0.7em] after:text-2xl"></div>
      </div>
      {Data.map((val, id) => (
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 relative bottom-[-6em] z-10"
          key={id}
        >
          {val.icons?.map((val, id) => (
            <div className="bg-white rounded-md shadow-md p-6" key={id}>
              <div>
                <div className="flex justify-center text-red-500 text-xl">
                  {val.icon}
                </div>
                <div className="font-semibold hover:text-amber-300 text-center py-3">
                  {val.note}
                </div>
                <div className="text-center leading-5">{val.details}</div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Service;
